import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { SupportHelp } from "@/features/support/components/support-help";
import { PageContainer } from "@/components/ui/page-container";

function SupportPage() {
  return (
    <PageContainer maxWidth="2xl">
      <SupportHelp />
    </PageContainer>
  );
}

export const supportRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/support",
  component: SupportPage,
});
